module.exports = __webpack_public_path__ + "static/media/setSeedSFX.d9d5e998.mp3";